import React from "react";
import { Badge, CloseButton } from "reactstrap";

interface FilterBadgeProps {
  className?: string;
  color?: string;
  label: string;
  value: string | undefined;
  onClose: () => void;
}

const FilterBadge = ({ className, color, label, value, onClose }: FilterBadgeProps) => {
  if (!value) return null;

  return <Badge
    className={className ?? "d-inline-flex align-items-center p-2 me-2"}
    color={color ?? "primary"}
    style={{ fontSize: '.9rem' }}>
    {label + ": " + value}
    <CloseButton
      onClick={onClose}
      className="ms-2"
      style={{ filter: "invert(1)", opacity: 1 }} />
  </Badge>
};

export default FilterBadge;